import { Skeleton } from '@/components/ui/skeleton.tsx'
import { DataTable } from '@/components/ui/table/data-table.tsx'
import type { ChatterTrackingEntryWithDateType } from '@/modules/tracking/chatter-tracking/service/chatter-tracking-service.ts'

import { getDetailedChatterLeaderboardColumns } from '../../../tracking/chatter-tracking/components/all-chatters-table/columns.tsx'

interface ChatterLeaderboardTableProps {
  data: ChatterTrackingEntryWithDateType[]
  isFetching: boolean
  isOneDay: boolean
}

export const DetailedChatterLeaderboardTable = ({
  data,
  isFetching,
  isOneDay,
}: ChatterLeaderboardTableProps) => {
  return (
    <div>
      <div className="flex items-center justify-between gap-4 max-md:flex-col max-md:items-start">
        <h3 className="text-2xl font-semibold text-text-default">
          Detailed Statistics
        </h3>
      </div>
      <div className="mt-6 grid">
        {isFetching && <Skeleton className="h-40 w-full" />}
        {!isFetching && (
          <DataTable
            enableSorting
            enablePagination
            columns={getDetailedChatterLeaderboardColumns(isOneDay)}
            data={data}
          />
        )}
      </div>
    </div>
  )
}
